export default __webpack_public_path__ + "static/media/Quicksand-SemiBold.d4f6bc51.ttf";